module.exports = __webpack_public_path__ + "static/media/private.fb909309.svg";